///ts:ref=BuySlot
/// <reference path="./BuySlot.ts"/> ///ts:ref:generated
class BuyButton extends BuySlot {

	constructor(tex: PIXI.Texture) {
		super();
		this.btn.icon.texture = tex;
		centerFrickingSprite(this.btn.icon);
	}
}
